// Api.
import api from '../Base';
import archiver from '../Archiver';

// Types.
import Event from '../../types/instance/Event';
import { TimeRangeContextType } from "../../context/TimeRangeContext";
import { showError } from '../../utils/showAlert';

const EventsApi = {

    getEventsChangesAndAlerts: async(timeRangeContext: TimeRangeContextType, instanceId: number) => {
        try {
            let url = `/rest/v2/event?${timeRangeContext.getTimeRangeQueryString()}&sort=timeslice+desc&limit=10000&datasourceid=${instanceId}`

            const response = await archiver.get(url)
            return response ? response.data : []
        } catch (error: any) {
            console.error('Failed to retrieve event data.', error);
            showError('Failed to retrieve event data', error.message || error.toString());
        }
    },

    getAllEventsChangesAndAlerts: async(timeRangeContext: TimeRangeContextType) => {
        try {
            let url = `/rest/v2/event?${timeRangeContext.getTimeRangeQueryString()}&sort=timeslice+desc&limit=10000`
            const response = await archiver.get(url)
            return response ? response.data : []
        } catch (error: any) {
            console.error('Failed to retrieve event data.', error);
            showError('Failed to retrieve event data', error.message || error.toString());
        }
    },

    getEventsChangesAndAlertsForHost: async(timeRangeContext: TimeRangeContextType, hostId: number) => {
        try {
            let url = `/rest/v2/event?${timeRangeContext.getTimeRangeQueryString()}&sort=timeslice+desc&limit=10000&hostid=${hostId}`

            const response = await archiver.get(url)
            return response ? response.data : []
        } catch (error: any) {
            console.error('Failed to retrieve event data for host.', error);
        }
    },

    getAllEvents: async(timeRangeContext: TimeRangeContextType) => {
        let url = `event?from=2020-01-01+00:00:00&to=${timeRangeContext.timeRange.to.format('YYYY-MM-DD+HH:mm:ss')}&tz=${timeRangeContext.timeRange.timezone}&interval=0&sort=eventId+desc&limit=50000`;
        let events: Event[] = [];

        await api.get<Event[]>(url)
            .then((response) => {
                events = response.data;
            })
            .catch((error: any) => {
                console.error('Failed to retrieve events.', error);
                showError('Failed to retrieve events', error.message || error.toString());
            });

        return events;
    }
}

export default EventsApi;
